var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVestLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.186954 0.18414C0.433195 -0.062101 0.83243 -0.062101 1.07867 0.18414L4.66046 3.76593C6.6115 2.02379 9.18563 0.964844 12.0071 0.964844C14.8269 0.964844 17.3996 2.02253 19.3502 3.76281L22.928 0.185C23.1743 -0.0612406 23.5735 -0.0612405 23.8198 0.185001C24.066 0.431242 24.066 0.830477 23.8198 1.07672L20.2421 4.65443C21.9832 6.60526 23.0415 9.17868 23.0415 11.9993C23.0415 14.8207 21.9826 17.3949 20.2405 19.3459L23.818 22.9234C24.0642 23.1697 24.0642 23.5689 23.818 23.8151C23.5717 24.0614 23.1725 24.0614 22.9262 23.8151L19.3485 20.2374C17.3981 21.9767 14.826 23.0337 12.0071 23.0337C9.18649 23.0337 6.61307 21.9754 4.66224 20.2342L1.08047 23.816C0.834233 24.0623 0.434997 24.0623 0.188756 23.816C-0.0574847 23.5698 -0.0574848 23.1705 0.188756 22.9243L3.77062 19.3424C2.03034 17.3918 0.972656 14.8191 0.972656 11.9993C0.972656 9.18037 2.02969 6.60833 3.76902 4.65793L0.186954 1.07586C-0.0592874 0.829617 -0.0592874 0.430381 0.186954 0.18414ZM12 20.9993C17.3977 20.9993 21 17.397 21 11.9993C21 6.60161 17.4048 2.99927 12.0071 2.99927C6.60942 2.99927 3 6.60161 3 11.9993C3 17.397 6.60232 20.9993 12 20.9993Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVestLight);
export default __webpack_public_path__ + "static/media/icon_vestLight.66376384430d47a518e85ef815ff910b.svg";
export { ForwardRef as ReactComponent };